import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetResultByDimensionAmbassadorV2Domain = (state) =>
  state.get("widgetResultByDimensionAmbassadorV2", initialState)

export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorV2Domain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorV2Domain, (state) =>
    state.get("dimensionsDrillDown")
  )

export const makeSelectDivisions = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorV2Domain, (state) =>
    state.get("divisions")
  )

export const makeSelectShowDimensionBenchmark = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorV2Domain, (state) =>
    state.get("showDimensionBenchmark")
  )

const makeSelectWidgetResultByDimensionAmbassadorV2 = () =>
  createSelector(selectWidgetResultByDimensionAmbassadorV2Domain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDimensionAmbassadorV2
export { selectWidgetResultByDimensionAmbassadorV2Domain }
